import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from './../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data?.map((item, index) => {
    return {
      id: `${index}`,
      value: item?.identificationNumber ?? '',
    }
  })
}

const getSubGroupIdsReq = (tokens: any, groupId) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getSubGroupIds),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      groupId,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getSubGroupIdsReq }
